import { render, staticRenderFns } from "./we-header-view.vue?vue&type=template&id=4b01c688&"
import script from "./we-header-view.vue?vue&type=script&lang=js&"
export * from "./we-header-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports